import React from 'react';
import {defaultErrorHandler} from '../../context/context';
import formService from '../../services/form-service';
import EntitySelector from '../../libs/react-components-admin/fields/entity-selector';

const FormSelector = ({className, label, forms, allowNull, hideWhenNoChoice, initialValue, onChange}) =>
  <EntitySelector id="form"
                  className={className}
                  label={label != null ? label : 'Form'}
                  fetchEntities={() => forms ?
                    Promise.resolve(forms) :
                    formService.findAllFormsCreatingDefaultIfEmpty()
                  }
                  errorHandler={defaultErrorHandler}
                  allowNull={allowNull}
                  hideWhenNoChoice={hideWhenNoChoice}
                  initialValue={initialValue}
                  onChange={v => onChange(v)}/>;

export default FormSelector;
